import { FC, ReactNode } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { AssistantStatusBadge } from '../assistant-status-badge';

export const AssistantTitle: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <div css={styles.container}>
      <AssistantStatusBadge />
      {typeof children === 'string' ? <Text size='large'>{children}</Text> : children}
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1)};
  `,
};
